export default {
  watch: {
    $route() {
      this.showMenuBar = false;
    },
  },
  methods: {
    scrollToContainerOrWindow(containerId) {
      const el = document.getElementById(containerId);

      if (el && el.scrollHeight > el.clientHeight) {
        el.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }

      const mainContainer = document.querySelector('.main-new-container');
      if (mainContainer) {
        mainContainer.scrollTo({ top: 0, behavior: "smooth" });
      }

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    isSameRoute(targetRoute) {
      const resolved = this.$router.resolve(targetRoute).route;

      return (
        resolved.path === this.$route.path &&
        JSON.stringify(resolved.query || {}) ===
          JSON.stringify(this.$route.query || {})
      );
    },
    async pushAndScroll(targetRoute, containerId) {
      if (!this.isSameRoute(targetRoute)) {
        await this.$router.push(targetRoute).catch(() => {});
      }

      this.$nextTick(() => {
        this.scrollToContainerOrWindow(containerId);
      });
    },
    async gotoBuilder(scrollTarget) {
      await this.pushAndScroll(
        {
          path: "builderpage",
          query: {
            scrollTo: scrollTarget,
          },
        },
        "builder-container"
      );
    },
    async gotoRecruitment() {
      await this.pushAndScroll(
        {
          path: "recruitment",
        },
        "recruitment-container"
      );
    },
    async goToAdminHome() {
      if (this.$route.name === "NewHomePage") {
        this.scrollToContainerOrWindow("home-container");
        return;
      }

      await this.pushAndScroll(
        {
          name: "HomePage",
        },
        "home-container"
      );
    },
    goToHomePage() {
      this.$router.push({
        name: "HomePage",
      }).catch(() => {});
    },
    async gotoAssessment() {
      await this.pushAndScroll(
        {
          name: "AssessmentPage",
        },
        "assesment-container"
      );
    },
    async gotoPanelist() {
      await this.pushAndScroll(
        {
          name: "PanelistPage",
        },
        "panelist-container"
      );
    },
    async gotoContact(scrollTarget) {
      this.showMenuBar = false;

      const route = { name: "ContactUs" };
      if (scrollTarget) {
        route.query = { scrollTo: scrollTarget };
      }
      
      if (!this.isSameRoute(route)) {
        await this.$router.push(route).catch(() => {});
      }

      this.$nextTick(() => {
        if (scrollTarget === 'contactUs') {
          const el = document.getElementById("contactUs-section");
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          this.scrollToContainerOrWindow("contact-container");
        }
      });
    },
    async gotoRequest() {
      await this.pushAndScroll(
        {
          name: "RequestDemo",
        },
        "demo-container"
      );
    },
    async goToInstructor() {
      await this.pushAndScroll(
        {
          name: "BecomeInstructor",
        },
        "instructor-container"
      );
    },
    async goToCareers() {
      await this.pushAndScroll(
        {
          name: "Careers",
        },
        "career-container"
      );
    },
    async goToPayment() {
      await this.pushAndScroll(
        {
          name: "PaymentsAndRefunds",
        },
        "payment-container"
      );
    },
    async goToUserManual() {
      await this.pushAndScroll(
        {
          name: "UserManual",
        },
        "user-manual-container"
      );
    },
    goToAppLogin() {
      window.open("https://app.hire3x.com/login");
    },
    goToCandidateLogin() {
      window.open("https://app.hire3x.com/login");
    },
    gotoRecruitmentLogin() {
      window.open("https://app.hire3x.com/login/?from=recruitment");
    },
    gotoAssessmentLogin() {
      window.open("https://app.hire3x.com/login/?from=assessment");
    },
    gotoCreatorLogin() {
      window.open("https://app.hire3x.com/login/?from=training");
    },
    goToLinkedIn() {
      window.open("https://www.linkedin.com/company/hire3x/");
    },
    goToRegister() {
      window.open("https://app.hire3x.com/register");
    },
    goToInstagram() {
      window.open(
        "https://www.instagram.com/hire3x/?igshid=MzRlODBiNWFlZA%3D%3D"
      );
    },
    goToFacebook() {
      window.open(
        "https://www.facebook.com/share/MZaKGzyFaEBBcZan/?mibextid=qi2Omg"
      );
    },
    goToYoutube() {
      window.open("https://youtube.com/@hire3x?si=cOgxeI16niM4l1kF");
    },
    async gotoTerms() {
      await this.pushAndScroll(
        {
          name: "TermsAndConditions",
        },
        "terms-container"
      );
    },
    async gotoPrivacy() {
      await this.pushAndScroll(
        {
          name: "PrivacyPolicy",
        },
        "privacy-container"
      );
    },
    gotoTrust() {
      this.$router.push({
        name: "TrustAndSafety",
      });
    },
    downloadTerms() {
      const link = document.createElement("a");
      link.href =
        "https://cvstaticfiles.s3.ap-south-1.amazonaws.com/candidate/documents/Terms+and+Conditions+Hire3x.docx";
      link.download = "Terms_and_Conditions_Hire3x.docx"; // Suggested filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadPrivacyPolicy() {
      window.open(
        "https://cvstaticfiles.s3.ap-south-1.amazonaws.com/candidate/documents/General+Privacy+Policy+for+hire3x.pdf"
      );
    },
    gotoTroubleshoot() {
      this.$router.push({
        name: "TroubleShooting",
      });
    },
  },
};
